import { Next } from '@securitize/ui-components';

export const QUALIFICATION_QUESTIONS_NEXT = new Next('/qualification-questions', 'QUALIFICATION_QUESTIONS');
export const SUBMIT_QUALIFICATION_QUESTIONS_NEXT = new Next('/qualification-questions',
  'SUBMIT_QUALIFICATION_QUESTIONS_NEXT', { method: 'POST' });
export const GET_QUALIFICATION_NEXT = new Next('/qualification', 'GET_QUALIFICATION');
